import React, { useState } from "react";
import { contactUsImg } from "../../../assets/images";
import {
  callicon,
  inputICon1,
  inputICon2,
  inputICon3,
  messageicon,
} from "../../../assets/icons";
import { Input, TextArea } from "../../../component/form";
import { AuthService } from "../../../services";
import { useMutation } from "@tanstack/react-query";
import useSnackbar from "../../../hooks/useSnackbar";
import CustomModal from "../../../component/modal/CustomModal";
import { IoClose } from "react-icons/io5";
import { FaCheck } from "react-icons/fa6";


const ContactUs = () => {
  const [input, setInput] = useState({ name: '', email: '', subject: '', message: '' })
  const [error, setError] = useState({ name: '', email: '', subject: '', message: '' })
  const [modal, setModal] = useState(false)
  const { queryApi } = AuthService();
  const { snackbar } = useSnackbar();
  // subject, message settings/submit_query
  // -------------onchange-------------
  const handleOnchange = (e) => {
    const { name, value } = e.target;
    setInput({ ...input, [name]: value })
  }
  // console.log('input', input)
  // -------------validation-------------
  const validation = () => {
    let status = true
    let errorMessage = {}
    if (!input?.name) {
      errorMessage['name'] = "Please enter name"
      status = false
    }
    if (!input?.email) {
      errorMessage['email'] = "Please enter email"
      status = false
    }
    if (!input?.subject) {
      errorMessage['subject'] = "Please enter Subject"
      status = false
    }
    if (!input?.message) {
      errorMessage['message'] = "Please enter message"
      status = false
    }
    setError(errorMessage)
    return status
  }

  // -----------------query-submit-----------------
  const handleSubmit = () => {
    if (validation()) {
      querySubmit.mutate(); // API call only if validation passes
    }
  };
  const querySubmit = useMutation({
    mutationFn: () => {
      return queryApi(input);
    },
    onSuccess: (data) => {
      setInput({ name: '', email: '', subject: '', message: '' });
      setError({});
      setModal(true)
      // snackbar(data?.message, 'info')
    },
    onError: (err) => {
      snackbar(err?.data?.message || "Something went wrong", "error");
    }
  });

  return (
    <div className="spacing" id="ContactUs">
      <div className="contact_us">
        <div className="container">
          <div className="content">
            <div className="page_title">
              <h2>Tell us more about yourself and what you’re got mind.</h2>
              <p>
                We’re here to help! Whether you have questions, need support, or
                want to share feedback, we’d love to hear from you.
              </p>
            </div>

            <form>
              <div className="form_field">
                <img src={inputICon1} alt="input-icon" className="icon" />
                <Input
                  type='text'
                  className="input form-control"
                  placeholder="Name"
                  name='name'
                  value={input?.name || ""}
                  onChange={handleOnchange}
                  error={error?.name}
                />
              </div>
              <div className="form_field">
                <img src={inputICon2} alt="input-icon" className="icon" />
                <Input
                  type='text'
                  className="input form-control"
                  placeholder="Email"
                  name='email'
                  value={input?.email || ""}
                  onChange={handleOnchange}
                  error={error?.email}
                />
              </div>
              <div className="form_field">
                <img src={inputICon3} alt="input-icon" className="icon" />
                <Input
                  type='text'
                  className="input form-control"
                  placeholder="Subject"
                  name='subject'
                  value={input?.subject || ""}
                  onChange={handleOnchange}
                  error={error?.subject}
                />
              </div>
              <div className="form_field">
                <TextArea
                  className="input form-control"
                  placeholder="How can we assist you?"
                  name='message'
                  value={input?.message || ""}
                  onChange={handleOnchange}
                  error={error?.message}
                />
              </div>
              <div className="button_wrap">
                <button
                  onClick={handleSubmit}
                  type="button"
                  className="button"
                >
                  Send Enquiry
                </button>
              </div>
            </form>
          </div>

          <div className="image_wrap">
            <img src={contactUsImg} alt="contact-image" />
            <div className="wrap_cards">
              <h2>
                For Assistance with <br /> Your Care, Contact Us!
              </h2>

              <ul>
                <li>
                  <img src={callicon} alt="call-icon" />
                  <a href="tel:+919999887833">+91 9999887833</a>
                </li>
                <li>
                  <img src={messageicon} alt="message-icon" />
                  <a href="mailto:support@holypills.in">
                   support@holypills.in
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* --------successfully-submit------------- */}
      <CustomModal
        show={modal}
        className={"logoutModal wrapper_plans_subscription wrapper_succesfull_toast"}
        closeButton={false}
      >
        <span className="close_button"
          onClick={() => setModal(false)}
        >
          <IoClose />
        </span>
        <div className="wrap_log_modal">
          <span className="wrap_span_icon">
           <FaCheck />
          </span>
          <p className="heading_p">Thank you!</p>
          <ul>
            <p>
              Your query has been successfully submitted!
            </p>
          </ul>
        </div>
      </CustomModal>
    </div>
  );
};

export default ContactUs;
